import React from 'react';
import { Box } from '@material-ui/core';
import SeniorLinks from './SeniorInformationComponents/SeniorLinks.jsx';

const SeniorTipsAndLinks = () => {
  return (
    <Box sx={{ width: '100%' }}>
      <SeniorLinks />
    </Box>
  );
};

export default SeniorTipsAndLinks;
